export default {"src":"/_next/static/media/gatewayfm_logo.0329a323.svg","height":167,"width":135,"blurWidth":0,"blurHeight":0};